
<div v-if="show" class="post-preview js-open-preview">
  <div class="post-preview__content">
    <app-post-preview-close-button @click.native="hide()" />
    <div class="post-preview__content-inner">
      <div class="post-preview__content-img">
        <img :src="imageurl" />
      </div>
      <div class="content-body">
        <div class="">
          <p class="content-body__text" v-text="text" />
          <div v-if="!!video_filename && !!video_url" class="content-body__video">
            <video :src="video_url" controls="controls" width="100%"></video>
          </div>
          <div class="content-body__buttons">
            <div v-if="!!pdf_file_url && !!pdf_file_filename" class="button">
              <a :href="pdf_file_url" target="_blank" rel="noopener noreferrer">
                {{ pdf_file_filename }}
                <i class="fa fa-file" aria-hidden="true"></i>
              </a>
            </div>
            <div v-if="!!button_external_url && !!button_external_title" class="button">
              <a :href="button_external_url" target="_blank" rel="noopener noreferrer">
                {{ button_external_title }}
                <i class="fa fa-external-link" aria-hidden="true"></i>
              </a>
            </div>
            <div v-if="!!button_reception_url && !!button_reception_title" class="button">
              <a
                :href="button_reception_url"
                target="_blank"
                rel="noopener noreferrer"
                class="reception"
              >
                {{ button_reception_title }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
